import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "card-body border-top d-flex justify-content-center" }
const _hoisted_17 = { class: "row mt-5" }
const _hoisted_18 = { class: "card-footer d-flex justify-content-end py-6 px-9 d-none" }
const _hoisted_19 = { class: "indicator-label" }
const _hoisted_20 = { class: "indicator-progress" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_transfer = _resolveComponent("el-transfer")!

  return (_ctx.can('create', 'groups'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewGroup')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translate('Group Name')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "title",
                    autocomplete: "off",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.translate('Group Name'),
                    modelValue: _ctx.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "title" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('shortDescription')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "description",
                    autocomplete: "off",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: _ctx.translate('shortDescription'),
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event))
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_transfer, {
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
                  data: _ctx.data
                }, null, 8, ["modelValue", "data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton",
                class: "btn btn-primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.groupPayload && _ctx.groupPayload(...args)))
              }, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('Next')), 1),
                _createElementVNode("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_21
                ])
              ], 512)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}